import styled from "styled-components";
import { mobile } from "../../../../../ui/_themes/constants";

export const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;

  right: ${({ isLeftHandMode }: { isLeftHandMode: boolean }) =>
    isLeftHandMode ? "0" : "auto"};
  padding: 0 1em;

  @media (orientation: landscape) {
    position: absolute;
    top: 0;
    height: 90%;
    width: ${mobile.landscape.sidePanel.width};
    padding: 1em 0;
    flex-direction: column;

    > div:nth-child(1) {
      margin-bottom: 0.5em;
    }
  }
  @media (orientation: portrait) {
    :first-child {
      /* This will be applied only if there is no Ticker on top */
      margin-top: 1em;
    }
  }
`;
